import { render, staticRenderFns } from "./practiceProvider.vue?vue&type=template&id=a7c98316&scoped=true&"
import script from "./practiceProvider.vue?vue&type=script&lang=js&"
export * from "./practiceProvider.vue?vue&type=script&lang=js&"
import style0 from "./practiceProvider.vue?vue&type=style&index=0&id=a7c98316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c98316",
  null
  
)

export default component.exports